module.exports = __webpack_public_path__ + "media/images/gallery/constellations/border_on-d4339fad33e1b46d197f3e205019ad43.png";